import React, { Component } from 'react'

import { connect } from 'react-redux'
import uploadSheet from '../actionCreators/uploadSheet'
import removeModel from '../actionCreators/removeModel'
import getModels from '../actionCreators/getModels'
import styled from 'styled-components'
import MainTable from './main/MainTable'
import { withRouter } from 'react-router'
import Success from './alerts/Success.tsx'
import StatusResponse from './alerts/StatusResponse'
import Preview from './preview/Preview.tsx'
import Importing from './alerts/importing.tsx'
import Uploading from './alerts/Uploading'
import SearchBar from './SearchBar'
import dismissModal from '../actionCreators/dismissModal'
import SelectSpreadsheetTab from './SelectSpreadsheetTab.tsx'
import UploadButton from './UploadButton'
import getPerspectives from '../actionCreators/getPerspectives'
import i18n from 'live/services/i18n'

class Main extends Component {
    state = {
        search: '',
        error: false,
        showAlerts: false,
        showModelSucess: false,
        expandPreview: false,
        isModel: false,
        model: '',
        perspective: 0,
        fileName: '',
        tab: 'databases'
    }

    handleChange = this.handleChange.bind(this)
    setPerspective = this.setPerspective.bind(this)
    setTabMenu = this.setTabMenu.bind(this)

    finishLoading = () => this.setState({ loading: false })
    closeErrorModal = () => this.setState({ error: false })
    expand = () => this.setState({ expandPreview: !this.state.expandPreview })

    upload = (history, file, isModel, eventType) => {
        const fileName = file.name

        this.setState({ model: eventType, fileName: fileName })

        if (isModel) {
            this.setState({ isModel: true })
            this.props.uploadSheet(history, file, isModel, eventType)
            this.setState({ showAlerts: true })
        } else {
            this.props.uploadSheet(history, file)
            this.setState({ isModel: false })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.error) this.setState({ error: true, loading: false })
    }
    UNSAFE_componentWillMount() {
        this.props.getModels()
        // this.props.getPerspectives()
    }

    handleChange(event) {
        this.setState({ search: event.target.value })
    }

    setPerspective(evt) {
        const perspectiveId = typeof evt.perspective.id == 'string' ? 0 : evt.perspective.id

        this.setState({ perspective: perspectiveId })
    }

    setTabMenu(tabName) {
        this.setState({ tab: tabName })
    }

    render() {
        const {
            history,
            historyModels = {},
            removeModelStatus,
            loadingModels,
            importing,
            isModel,
            models,
            importingMessage,
            uploading,
            statusCode,
            preview,
            perspectives,
            uploadSheet,
            error,
            errorMessage,
            location,
            removeModel
        } = this.props
        const { status = null, msg } = removeModelStatus

        const search = String(new URLSearchParams(String(location?.search)).get('query') || '')

        return (
            <>
                <MainContainer>
                    <>
                        <SearchContainer>
                            <UploadButton
                                upload={this.upload}
                                history={history}
                                updateModels={this.props.getModels.bind(this)}
                            />
                            <SearchBar
                                onChange={({ target }) => {
                                    this.props.history.push({
                                        pathname: '/datasorce',
                                        search: `?${new URLSearchParams({ query: target?.value }).toString()}`
                                    })
                                }}
                                value={search}
                                type={'Database'}
                            />
                            {/* TODO:  what this filter should do, commented because it has no function in the UI*/}
                            {/* <FilterButton>
                            <i className="far fa-filter"></i>
                        </FilterButton> */}
                        </SearchContainer>
                        {loadingModels ? (
                            <LoadingIconCenter
                                className="fa fa-spinner fa-spin fa-4x"
                                aria-hidden="true"
                            ></LoadingIconCenter>
                        ) : (
                            <MainTable
                                models={models}
                                upload={this.upload}
                                search={search}
                                historyModels={historyModels}
                                history={history}
                                removeModel={removeModel}
                                param={new URLSearchParams(String(location?.search))}
                            />
                        )}
                    </>
                </MainContainer>

                <Preview
                    expand={this.expand}
                    match={this.props.match}
                    expanded={this.state.preview}
                    fileName={this.state.fileName}
                    isModel={isModel}
                    history={history}
                    eventType={this.state.model}
                    perspective={this.state.perspective}
                />

                <SelectSpreadsheetTab fileName={this.state.fileName} eventType={this.state.model} />

                {this.props.importedModel ? (
                    <Success
                        onClick={() => {
                            this.setState({ showAlerts: false })
                            this.props.dismissModal()
                        }}
                    />
                ) : null}

                {importing ? <Importing /> : null}

                {uploading ? <Uploading importingMessage={importingMessage} /> : null}

                {error || this.props.importedModelError ? (
                    <StatusResponse
                        show={true}
                        onClick={() => {
                            this.setState({ showAlerts: false })
                            this.props.dismissModal()
                        }}
                        msg={
                            this.props.importedModelErrorMsg ||
                            i18n('Error importing spreadsheet. Check the file and try again.')
                            //  Mensagem de erro: {errorMessage}."
                        }
                        status={statusCode}
                    />
                ) : null}
            </>
        )
    }
}
const FilterButton = styled.div`
    width: 30px;
    height: 32px;
    margin-left: 10px;
    color: #37a3ef;
    border: 1px solid var(--gray-400);
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
`
const SearchContainer = styled.div`
    /* height: 50px; */
    /* background-color: white; */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    /* padding: 0 0.4rem; */
    padding: 10px 10%;
`

const LoadingIconCenter = styled.i`
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
`

const MainContainer = styled.div`
    font-family: arial, sans-serif;
    height: 100%;
    overflow-y: hidden;
    position: relative;
    background-color: var(--gray-0);
`

const PreviewContainer = styled.div`
    /* flex: 1; */
    transition: all 2s;
    height: 100%;
    overflow: auto;
`
const DropContainer = styled.div`
    height: 100px;
    border: 1px solid #dddee1;
`

function mapStateToProps({ sheet }) {
    return {
        isModel: sheet.isModel,
        error: sheet.error || false,
        preview: sheet.preview || false,
        errorMessage: sheet.data || '',
        statusCode: sheet.statusCode,
        models: sheet.models,
        perspectives: sheet.perspectives || [],
        importing: sheet.importing,
        importingMessage: sheet.importingMessage,
        uploading: sheet.uploading,
        loadingModels: sheet.loadingModels,
        historyModels: sheet.historyModels,
        importedModel: sheet.importedModel,
        importedModelError: sheet.importedModelError,
        importedModelErrorMsg: sheet.importedModelErrorMsg,
        removeModelStatus: sheet.removeModelStatus || {}
    }
}
export default withRouter(
    connect(mapStateToProps, {
        getModels,
        uploadSheet,
        removeModel,
        dismissModal,
        getPerspectives
    })(Main)
)

export { LoadingIconCenter }
